import { ofType } from 'redux-observable';
import { debounceTime, switchMap, map, catchError } from 'rxjs/operators';
import { from, of } from 'rxjs';
import { FETCH_ACCESSORY_LIST_REQUEST, EPIC_ERROR } from 'Constants/redux';
import service from 'Api/service';
import { receiveAccessoryList } from 'Actions';

const fetchAccessoryListEpic = (action$) =>
  action$.pipe(
    ofType(FETCH_ACCESSORY_LIST_REQUEST),
    debounceTime(500),
    switchMap((action) =>
      from(
        service.post(
          `${import.meta.env.VITE_API_DOMAIN}/api/accessories/list?page=all`,
          action.options
        )
      ).pipe(
        map((response) => receiveAccessoryList(response.data.accessories)),
        catchError((error) => {
          console.error('fetchAccessoryListEpic error', error);
          return of({ type: EPIC_ERROR });
        })
      )
    )
  );

export default fetchAccessoryListEpic;
